import './ActionMenu.scss';

import React from 'react';

export default class ActionMenu extends React.Component {
    static propTypes = {
        className: React.PropTypes.string,
        onClick: React.PropTypes.func,
        onClose: React.PropTypes.func
    };

    closeActionMenu(event) {
        event.stopPropagation();
        let target = event.target;
        while(target.getAttribute('class') === null || target.getAttribute('class').indexOf('active') === -1) {
            target = target.parentNode;
        }

        target.classList.remove('active');

        if(this.props.onClose) {
            this.props.onClose();
        }
    }

    render() {
        let { className } = this.props;
        return (
            <div className={`action-menu ${className || ''}`}
                 onClick={this.closeActionMenu.bind(this)}>
                <div className="action-menu__actions">
                    {this.props.children}
                    <div role="button"
                         className="action-menu__cancel">
                        Cancel
                    </div>
                </div>
                <div className="action-menu__background">
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/ActionMenu/index.js